import { Grid, Toolbar, useMediaQuery } from "@mui/material";
import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import Header from "../header/header";
import { useStyle } from "./style";

const MainLayout = () => {
  const classes = useStyle();
  const isScreenLarge = useMediaQuery('(min-width:900px)');

  return (
    <Fragment>
      <div className={classes.backDropDiv} />
          <Header />
          <Toolbar />
          <Grid className={classes.mainGrid}>
            <Outlet />
          </Grid>
    </Fragment>
  );
};

export default MainLayout;
